export const TOKEN_EXPIRY_SKEW_MS = 30000;
/**
 * Best-effort local check for an expired JWT access token. Returns false for
 * malformed tokens — the server remains the authority either way. Shared by
 * the queue socket's sign-in and the API client's request path.
 *
 * @param {string|undefined} token - The access token.
 * @returns {boolean} True when the token expires within 30 s or has expired.
 */
export function isAccessTokenExpired(token) {
    if (!token) {
        return false;
    }
    try {
        const payloadPart = token.split('.')[1];
        if (!payloadPart) {
            return false;
        }
        const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(normalized));
        if (typeof payload.exp !== 'number') {
            return false;
        }
        return Date.now() + TOKEN_EXPIRY_SKEW_MS >= payload.exp * 1000;
    }
    catch {
        return false;
    }
}
